import React, {useState, useMemo, useCallback} from "react";
import S from './Photo.module.scss';
import {Carousel} from "@mantine/carousel";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import {announcements} from "../../shared/mock/partners";
import rutube from "../../shared/assets/images/rutube.png";

interface PhotoProps {
    photo: any,
}

export const Photo = ({ photo }: PhotoProps) => {
    const [index, setIndex] = useState(-1);
    const [loadedImages, setLoadedImages] = useState<Set<number>>(new Set());

    const slides = useMemo(
        () => photo?.map((src: any) => ({ src })) || [],
        [photo]
    );
    const handleSlideChange = useCallback((index: number) => {
        const toLoad = [index, index + 1, index - 1];
        toLoad.forEach(i => {
            if (i >= 0 && i < photo.length) {
                setLoadedImages(prev => new Set(prev).add(i));
            }
        });
    }, [photo.length]);


    const handleSlideClick = useCallback((index: number) => {
        setIndex(index);
    }, []);

    return (
        <div className={S.titleBox}>
            <div className={S.title}>КАК ЭТО БЫЛО</div>
            <Carousel
                classNames={{controls: S.controls, indicator: S.indicator, root: S.carouselRoot}}
                withIndicators={photo?.length > 2}
                slideSize={{base: '80%', sm: '70%', md: '40%'}}
                slideGap={{base: 0, sm: 'md'}}
                emblaOptions={{loop: true, align: 'start', containScroll: 'trimSnaps', duration: 20}}
                onSlideChange={handleSlideChange}
                initialSlide={0}
                withControls={photo?.length > 2}
            >
                {photo?.map((image: any, index: number) => {
                    const isLoaded = loadedImages.has(index) || index < 5;

                    return (
                        <Carousel.Slide
                            key={index}
                            onClick={() => handleSlideClick(index)}
                            className={S.carouselSlide}
                        >
                            {isLoaded ? (
                                <img
                                    src={image}
                                    alt={`photo ${index + 1}`}
                                    className={S.carouselImage}
                                    loading="lazy"
                                    decoding="async"
                                />
                            ) : (
                                <div>Загрузка...</div>
                            )}
                        </Carousel.Slide>
                    )
                })}
            </Carousel>

            <Lightbox
                index={index}
                open={index >= 0}
                close={() => setIndex(-1)}
                slides={slides}
                plugins={[Thumbnails, Zoom]}
                carousel={{
                    spacing: "4px",
                    padding: "4px",
                    finite: false,
                }}
                zoom={{
                    maxZoomPixelRatio: 3,
                    zoomInMultiplier: 2,
                    doubleClickDelay: 300,
                    doubleTapDelay: 300,
                    keyboardMoveDistance: 50,
                    wheelZoomDistanceFactor: 100,
                    pinchZoomDistanceFactor: 100,
                    scrollToZoom: true
                }}
                render={{
                    buttonPrev: undefined,
                    buttonNext: undefined,
                }}
                animation={{fade: 200, swipe: 200, navigation: 200}}
            />

            <div className={S.linkDiv}>
                <img src={rutube} alt="rutube"/>
                <a href="https://rutube.ru/channel/80952490" target="_blank" rel="noreferrer">
                    Смотреть на RUTUBE
                </a>
            </div>
        </div>
    );
};